// // src/pages/Login.js
// import React from 'react';
// import {
//   TextField,
//   Button,
//   Container,
//   Typography,
//   Box,
//   Paper,
//   Grid,
//   Avatar,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { Formik, Form, Field, ErrorMessage } from 'formik';
// import * as Yup from 'yup';
// import authService from '../services/authService';
// import verify360 from '../assets/images/dark-logo.svg'; // Adjust the path as necessary
// import vdhmLogo from '../assets/images/culcutta-event.png'; // Adjust the path as necessary

// // Validation schema using Yup
// const validationSchema = Yup.object().shape({
//   phone: Yup.string()
//     .required('Phone is required.')
//     .matches(/^[0-9]{10}$/, 'Phone must be a valid 10-digit number.'),
//   password: Yup.string().required('Password is required.'),
// });

// const Login = () => {
//   const navigate = useNavigate();

//   const handleSubmit = async (values, { setSubmitting, setErrors }) => {
//     try {
//       const res = await authService.login(values.phone, values.password);
//       if (res) {
//         localStorage?.setItem('user_id', res?.user_id);
//         localStorage?.setItem('event_id', res?.event_id);
//       }
//       navigate('/events');
//     } catch (error) {
//       setErrors({ api: 'Login failed. Please check your credentials.' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Container maxWidth='xs'>
//       <Paper
//         elevation={3}
//         sx={{
//           padding: 3,
//           borderRadius: 2,
//           mt: 8,
//           textAlign: 'center',
//         }}
//       >
//          <Box sx={{display:'flex', justifyContent:'flex-end'}}>
//          <img
//             src={verify360}
//             alt="Logo 1"
//             style={{ width: 130, height: 40,  }}
//           />
//           </Box>
//           <Box>
//         <img
//             src={vdhmLogo}
//             alt="Logo 2"
//           />
//          </Box>
//         {/* <Typography variant='h4' gutterBottom>
//           Login
//         </Typography> */}
//         <Formik
//           initialValues={{ phone: '', password: '' }}
//           validationSchema={validationSchema}
//           onSubmit={handleSubmit}
//         >
//           {({ isSubmitting }) => (
//             <Form>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <h5 style={{ margin: 0 , display:'flex'}}>Phone</h5>
//                   <Field
//                     as={TextField}
//                     name='phone'
//                     fullWidth
//                     variant='outlined'
//                     helperText={<ErrorMessage name='phone' />}
//                     error={!!(<ErrorMessage name='phone' />)}
//                     sx={{
//                       '& .MuiOutlinedInput-input': {
//                         padding: '8.5px 9px',
//                       },
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <h5 style={{ margin: 0, display:'flex' }}>Password</h5>
//                   <Field
//                     as={TextField}
//                     type='password'
//                     name='password'
//                     fullWidth
//                     variant='outlined'
//                     helperText={<ErrorMessage name='password' />}
//                     error={!!(<ErrorMessage name='password' />)}
//                     sx={{
//                       '& .MuiOutlinedInput-input': {
//                         padding: '8.5px 9px',
//                       },
//                     }}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Button
//                     type='submit'
//                     variant='contained'
//                     color='primary'
//                     fullWidth
//                     disabled={isSubmitting}
//                     sx={{ textTransform: 'none' }}
//                   >
//                     Login
//                   </Button>
//                 </Grid>
//               </Grid>
//               <Box mt={2} textAlign='center'>
//                 <ErrorMessage
//                   name='api'
//                   component='div'
//                   style={{ color: 'red' }}
//                 />
//               </Box>
//             </Form>
//           )}
//         </Formik>

//       </Paper>
//     </Container>
//   );
// };

// export default Login;

// src/pages/Login.js
// import React from 'react';
// import {
//   TextField,
//   Button,
//   Container,
//   Typography,
//   Box,
//   Paper,
//   Grid,
//   Checkbox,
//   FormControlLabel,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import { Formik, Form, Field, ErrorMessage } from 'formik';
// import * as Yup from 'yup';
// import authService from '../services/authService';
// import eventLogo from '../assets/images/culcutta-event.png';
// import verify360 from '../assets/images/verify360-logo.svg';
// import procam360 from '../assets/images/pro360.svg';
// import '../assets/css/Login.css'; // Custom CSS for additional styling
// import { isEmpty } from 'lodash';
// import { toast } from 'react-toastify';

// // Validation schema using Yup
// const validationSchema = Yup.object().shape({
//   phone: Yup.string()
//     .required('Phone is required.')
//     .matches(/^[0-9]{10}$/, 'Phone must be a valid 10-digit number.'),
//   password: Yup.string().required('Password is required.'),
// });

// const Login = () => {
//   const navigate = useNavigate();

//   const handleSubmit = async (values, { setSubmitting, setErrors }) => {
//     try {
//       const res = await authService.login(values.phone, values.password);
//       // if (res) {
//       //   localStorage?.setItem('user_id', res?.user_id);
//       //   localStorage?.setItem('event_id', res?.event_id);
//       //   localStorage?.setItem('user_name', res?.username)
//       // }
//       const loginRole = res?.roles ? JSON.parse(res.roles)[0] : null;

//       if (res) {
//         const {
//           event_id,
//           roles = [],
//           permissions = [],
//           user_id,
//           username,
//         } = {
//           ...res,
//           roles: loginRole
//             ? loginRole === 'ADMIN'
//               ? ['ADMIN', 'SUPER ADMIN']
//               : loginRole === 'SUPERVISOR'
//               ? ['SUPERVISOR', 'ADMIN', 'SUPER ADMIN']
//               : JSON.parse(res.roles)
//             : [],
//           permissions: res?.permissions ? JSON.parse(res.permissions) : [],
//           product_types: res?.product_types
//             ? JSON.parse(res.product_types)
//             : [],
//           department_name: res?.department_name
//             ? JSON.parse(res.department_name)
//             : [],
//         };

//         localStorage?.setItem('event_id', event_id);
//         localStorage?.setItem('permissions', JSON.stringify(permissions));
//         localStorage?.setItem('roles', JSON.stringify(roles));
//         localStorage?.setItem('user_id', user_id);
//         localStorage?.setItem('user_name', username);
//         localStorage?.setItem('phone', values.phone);

//         if (roles?.includes('USER')) {
//           toast?.error('You do not have any permission view the pages!!');
//         } else {
//           if (roles?.includes('STATION MANAGER')) {
//             navigate('/stationUpdate');
//           } else {
//             navigate('/users');
//           }
//         }
//       }
//     } catch (error) {
//       setErrors({ api: 'Login failed. Please check your credentials.' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Container maxWidth='sm' className='login-container'>
//       <Grid container spacing={2} justifyContent='center' alignItems='center'>
//         {/* Left side with form */}
//         <Grid item xs={12} sm={9}>
//           <Paper elevation={3} className='login-form'>
//           <Box textAlign='center' mb={2}>
//             <img src={procam360} width='220' height='84' alt='Procam' />
//           </Box>
//           <Formik
//             initialValues={{ phone: '', password: '', rememberMe: false }}
//             validationSchema={validationSchema}
//             onSubmit={handleSubmit}
//           >
//             {({ isSubmitting }) => (
//               <Form>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12}>
//                     <Typography variant='body2' className='input-label'>
//                       Username
//                     </Typography>
//                     <Field
//                       as={TextField}
//                       name='phone'
//                       fullWidth
//                       variant='outlined'
//                       helperText={<ErrorMessage name='phone' />}
//                       error={!!(<ErrorMessage name='phone' />)}
//                       InputProps={{ style: { padding: '8px' } }}
//                       inputProps={{
//                         maxLength: 10,
//                         pattern: '[0-9]{10}',
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12}>
//                     <Typography variant='body2' className='input-label'>
//                       Password
//                     </Typography>
//                     <Field
//                       as={TextField}
//                       type='password'
//                       name='password'
//                       fullWidth
//                       variant='outlined'
//                       helperText={<ErrorMessage name='password' />}
//                       error={!!(<ErrorMessage name='password' />)}
//                       InputProps={{ style: { padding: '8px' } }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} container justifyContent='flex-end'>
//                     {/* <FormControlLabel
//                       control={
//                         <Field
//                           as={Checkbox}
//                           name='rememberMe'
//                           color='primary'
//                         />
//                       }
//                       label='Remember'
//                     /> */}
//                     <Typography variant='body2' className='forgot-password'>
//                       Forgot Password?
//                     </Typography>
//                   </Grid>
//                   <Grid item xs={12}>
//                     <Button
//                       type='submit'
//                       variant='contained'
//                       fullWidth
//                       disabled={isSubmitting}
//                       className='submit-button'
//                     >
//                       Submit
//                     </Button>
//                   </Grid>
//                 </Grid>
//                 <Box mt={2} textAlign='center'>
//                   <ErrorMessage
//                     name='api'
//                     component='div'
//                     className='error-message'
//                   />
//                 </Box>
//               </Form>
//             )}
//           </Formik>
//           </Paper>
//         </Grid>

//         {/* Right side illustration */}
//         {/* Right side illustration */}
//         {/* <Grid item xs={12} sm={6} className='illustration-container'>
//           <Box className='logo-container'>
//             <img
//               src={eventLogo}
//               width='225'
//               height='95'
//               alt='tata steel world 25k'
//             />
//             <img src={procam} width='200' height='84' alt='Procam' />
//             <img src={verify360} width='200' height='84' alt='Verify360' />
//           </Box>
//         </Grid> */}
//       </Grid>
//     </Container>
//   );
// };

// export default Login;

import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Form, Formik } from 'formik';
import { find, isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import '../assets/css/Login.css'; // Custom CSS
import desktopBackground from '../assets/images/people-jogging-desk.jpg'; // Background image
import mobileBackground from '../assets/images/people-jogging-mob.jpg'; // Background image
import logo from '../assets/images/pro360.png'; // Pro360 Logo
import authService from '../services/authService';
import eventService from '../services/eventService';
import { createUserOtp } from '../utils/userOtp';

// Validation schema using Yup
const getValidationSchema = (isMobile) =>
  Yup.object().shape({
    phone: Yup.string()
      .required('Phone is required.')
      .matches(/^[0-9]{10}$/, 'Phone must be a valid 10-digit number.'),
    password: isMobile
      ? Yup.string()
      : Yup.string().required('Password is required.'),
    otp: isMobile
      ? Yup.string()
          .required('OTP is required.')
          .matches(/^[0-9]{6}$/, 'OTP must be a 6-digit code.')
      : Yup.string(),
  });

// const Login = () => {
//   const navigate = useNavigate();

//   const handleSubmit = async (values, { setSubmitting, setErrors }) => {
//     try {
//       const res = await authService.login(values.phone, values.password);
//       // if (res) {
//       //   localStorage?.setItem('user_id', res?.user_id);
//       //   localStorage?.setItem('event_id', res?.event_id);
//       //   localStorage?.setItem('user_name', res?.username)
//       // }
//       const loginRole = res?.roles ? JSON.parse(res.roles)[0] : null;

//       if (res) {
//         const {
//           event_id,
//           roles = [],
//           permissions = [],
//           user_id,
//           username,
//           gps_units_id,
//           stations,
//           products,
//         } = {
//           ...res,
//           roles: loginRole
//             ? loginRole === 'ADMIN'
//               ? ['ADMIN', 'SUPER ADMIN']
//               : loginRole === 'SUPERVISOR'
//               ? ['SUPERVISOR', 'ADMIN', 'SUPER ADMIN']
//               : JSON.parse(res.roles)
//             : [],
//           permissions: res?.permissions ? JSON.parse(res.permissions) : [],
//           product_types: res?.product_types
//             ? JSON.parse(res.product_types)
//             : [],
//           department_name: res?.department_name
//             ? JSON.parse(res.department_name)
//             : [],
//           products:
//             res?.products && !isEmpty(res?.products)
//               ? JSON.parse(res?.products)
//               : [],
//           stations:
//             res?.station && !isEmpty(res?.station)
//               ? JSON.parse(res?.station)
//               : [],
//         };

//         localStorage?.setItem('event_id', event_id);
//         localStorage?.setItem('permissions', JSON.stringify(permissions));
//         localStorage?.setItem('roles', JSON.stringify(roles));
//         localStorage?.setItem('user_id', user_id);
//         localStorage?.setItem('user_name', username);
//         localStorage?.setItem('phone', values.phone);
//         localStorage?.setItem('stations', JSON.stringify(stations));
//         localStorage?.setItem('products', JSON.stringify(products));

//         const hasPermission = (permission) => permissions.includes(permission);

//         if (localStorage?.getItem('roles')) {
//           if (roles?.includes('USER')) {
//             if (hasPermission('AMBULANCE GPS')) {
//               if (gps_units_id) {
//                 navigate(`/ambulance/${gps_units_id}`);
//               } else {
//                 toast?.error('GPS unit id is not found!!');
//               }
//             } else if (hasPermission('SUPERVISOR FORM')) {
//               navigate(`/stockHistory`);
//             } else if (
//               ['ALLOTED ITEM', 'DELIVERED ITEM', 'PICKED-UP ITEM'].some(
//                 (item) => hasPermission(item)
//               )
//             ) {
//               if (hasPermission('ALLOTED ITEM')) {
//                 navigate('/userAccess?tab=inward');
//               } else if (hasPermission('DELIVERED ITEM')) {
//                 navigate('/userAccess?tab=delivered');
//               } else if (hasPermission('PICKED-UP ITEM')) {
//                 navigate('/userAccess?tab=pickup');
//               }
//             }
//             // toast?.error('You do not have any permission view the pages!!');
//           } else {
//             if (roles?.includes('STATION MANAGER')) {
//               navigate('/stationUpdate');
//             } else {
//               navigate('/users');
//             }
//           }
//         }
//       }
//     } catch (error) {
//       setErrors({ api: 'Login failed. Please check your credentials.' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         justifyContent: 'center',
//         paddingBottom: '18rem !important',
//         paddingTop: '4rem!important',
//         alignItems: 'center', // Aligns content to the top
//         height: '100vh',
//         background: `url(${background}) no-repeat center center fixed`,
//         backgroundSize: 'cover',
//         padding: 2, // Add padding to prevent content from touching the edges
//       }}
//     >
//       <Paper
//         elevation={6}
//         sx={{
//           width: '100%', // Make the width 100% on small screens
//           maxWidth: 400, // Limit to 400px max width for larger screens
//           p: 4,
//           borderRadius: 3,
//           backdropFilter: 'blur(1px)',
//           backgroundColor: 'rgba(255, 255, 255, 0.7)',
//           boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)', // Slight shadow for better contrast
//         }}
//       >
//         <Box textAlign='center' mb={2}>
//           <img src={PRO360} alt='Pro360 Logo' style={{ width: 200 }} />
//           <Typography
//             variant='h5'
//             mt={1}
//             sx={{ color: '#001586', fontWeight: 500 }}
//           >
//             Login Account
//           </Typography>
//           <Typography variant='body2' color='textSecondary'>
//             Enter your credentials to access your account.
//           </Typography>
//         </Box>

//         <Formik
//           initialValues={{ phone: '' }}
//           validationSchema={validationSchema}
//           onSubmit={(values) => {
//             handleSubmit(values);
//           }}
//         >
//           {({ isSubmitting, touched, errors, handleChange }) => (
//             <Form>
//               <Grid container spacing={2}>
//                 <Grid item xs={12}>
//                   <TextField
//                     fullWidth
//                     placeholder='Phone'
//                     variant='outlined'
//                     name='phone'
//                     onChange={handleChange}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment
//                           position='start'
//                           sx={{ mr: '0 !important' }}
//                         >
//                           <Box
//                             sx={{
//                               width: '5px',
//                               height: '31px',
//                               backgroundColor: '#001586',
//                             }}
//                           />
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         paddingLeft: '1px',
//                         backgroundColor: 'transparent',
//                         boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//                         '& fieldset': {
//                           border: '1px solid #DDD',
//                         },
//                         '&:hover fieldset': {
//                           borderColor: '#1876D1',
//                         },
//                         '&.Mui-focused fieldset': {
//                           borderColor: '#1876D1',
//                         },
//                       },
//                       '& input': {
//                         padding: '12px 20px',
//                         fontSize: '16px',
//                         color: '#555',
//                       },
//                     }}
//                     error={touched.phone && !!errors.phone}
//                     helperText={touched.phone && errors.phone}
//                   />
//                 </Grid>

//                 <Grid item xs={11} sx={{ mb: 2 }}>
//                   <TextField
//                     fullWidth
//                     type='password'
//                     name='password'
//                     onChange={handleChange}
//                     placeholder='Password'
//                     variant='outlined'
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment
//                           position='start'
//                           sx={{ mr: '0 !important' }}
//                         >
//                           <Box
//                             sx={{
//                               width: '5px',
//                               height: '37px',
//                               backgroundColor: '#001586',
//                               // marginRight: '10px',
//                             }}
//                           />
//                         </InputAdornment>
//                       ),
//                     }}
//                     sx={{
//                       '& .MuiOutlinedInput-root': {
//                         // borderRadius: '25px',
//                         paddingLeft: '1px',
//                         backgroundColor: 'transparent',
//                         boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//                         '& fieldset': {
//                           border: '1px solid #DDD',
//                         },
//                         '&:hover fieldset': {
//                           borderColor: '#1876D1',
//                         },
//                         '&.Mui-focused fieldset': {
//                           borderColor: '#1876D1',
//                         },
//                       },
//                       '& input': {
//                         padding: '12px 20px',
//                         fontSize: '16px',
//                         color: '#555',
//                       },
//                     }}
//                     error={touched.password && !!errors.password}
//                     helperText={touched.password && errors.password}
//                   />
//                 </Grid>

//                 <Grid item xs={12}>
//                   <Button
//                     type='submit'
//                     variant='contained'
//                     fullWidth
//                     disabled={isSubmitting}
//                     sx={{
//                       backgroundColor: '#001586',
//                       color: '#fff',
//                       borderRadius: 4,
//                       '&:hover': {
//                         backgroundColor: '#155a8a',
//                       },
//                     }}
//                   >
//                     Login
//                   </Button>
//                 </Grid>
//               </Grid>
//             </Form>
//           )}
//         </Formik>
//       </Paper>
//     </Box>

//     // <Box
//     //   sx={{
//     //     display: 'flex',
//     //     justifyContent: 'center',
//     //     alignItems: 'center',
//     //     height: '100vh',
//     //     background: `url(${background}) no-repeat center center fixed`,
//     //     backgroundSize: 'cover',
//     //   }}
//     // >
//     //   <Paper
//     //     elevation={6}
//     //     sx={{
//     //       width: 400,
//     //       p: 4,
//     //       ml: '35rem',
//     //       mt: 6,
//     //       borderRadius: 3,
//     //       backdropFilter: 'blur(1px)', // Retains blur effect
//     //       backgroundColor: 'rgba(255, 255, 255, 0.5)', // Adjust alpha to 0.5 for more transparency
//     //     }}
//     //   >
//     //     <Box textAlign='center' mb={3}>
//     //       <img src={logo} alt='Pro360 Logo' style={{ width: 250 }} />
//     //       <Typography
//     //         variant='h5'
//     //         mt={1}
//     //         sx={{ color: '#001586', fontWeight: 500 }}
//     //       >
//     //         Login Account
//     //       </Typography>
//     //       <Typography variant='body2' color='textSecondary'>
//     //         Enter your credentials to access your account.
//     //       </Typography>
//     //     </Box>
//     //     <Formik
//     //       initialValues={{ phone: '', password: '' }}
//     //       validationSchema={validationSchema}
//     //       onSubmit={handleSubmit}
//     //     >
//     //       {({ isSubmitting, touched, errors, handleChange }) => (
//     //         <Form>
//     //           <Grid container spacing={2}>
//     //             <Grid item xs={11} sx={{ mb: 2 }}>
//     //               <TextField
//     //                 fullWidth
//     //                 placeholder='Phone'
//     //                 variant='outlined'
//     //                 name='phone'
//     //                 onChange={handleChange}
//     //                 InputProps={{
//     //                   startAdornment: (
//     //                     <InputAdornment
//     //                       position='start'
//     //                       sx={{ mr: '0 !important' }}
//     //                     >
//     //                       <Box
//     //                         sx={{
//     //                           width: '5px',
//     //                           height: '37px',
//     //                           backgroundColor: '#001586',
//     //                           // marginRight: '10px',
//     //                         }}
//     //                       />
//     //                     </InputAdornment>
//     //                   ),
//     //                 }}
//     //                 sx={{
//     //                   '& .MuiOutlinedInput-root': {
//     //                     // borderRadius: '25px',
//     //                     paddingLeft: '1px',
//     //                     backgroundColor: 'transparent',
//     //                     boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//     //                     '& fieldset': {
//     //                       border: '1px solid #DDD',
//     //                     },
//     //                     '&:hover fieldset': {
//     //                       borderColor: '#1876D1',
//     //                     },
//     //                     '&.Mui-focused fieldset': {
//     //                       borderColor: '#1876D1',
//     //                     },
//     //                   },
//     //                   '& input': {
//     //                     padding: '12px 20px',
//     //                     fontSize: '16px',
//     //                     color: '#555',
//     //                   },
//     //                 }}
//     //                 error={touched.phone && !!errors.phone}
//     //                 helperText={touched.phone && errors.phone}
//     //               />
//     //             </Grid>

//     //             <Grid item xs={11} sx={{ mb: 2 }}>
//     //               <TextField
//     //                 fullWidth
//     //                 type='password'
//     //                 name='password'
//     //                 onChange={handleChange}
//     //                 placeholder='Password'
//     //                 variant='outlined'
//     //                 InputProps={{
//     //                   startAdornment: (
//     //                     <InputAdornment
//     //                       position='start'
//     //                       sx={{ mr: '0 !important' }}
//     //                     >
//     //                       <Box
//     //                         sx={{
//     //                           width: '5px',
//     //                           height: '37px',
//     //                           backgroundColor: '#001586',
//     //                           // marginRight: '10px',
//     //                         }}
//     //                       />
//     //                     </InputAdornment>
//     //                   ),
//     //                 }}
//     //                 sx={{
//     //                   '& .MuiOutlinedInput-root': {
//     //                     // borderRadius: '25px',
//     //                     paddingLeft: '1px',
//     //                     backgroundColor: 'transparent',
//     //                     boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
//     //                     '& fieldset': {
//     //                       border: '1px solid #DDD',
//     //                     },
//     //                     '&:hover fieldset': {
//     //                       borderColor: '#1876D1',
//     //                     },
//     //                     '&.Mui-focused fieldset': {
//     //                       borderColor: '#1876D1',
//     //                     },
//     //                   },
//     //                   '& input': {
//     //                     padding: '12px 20px',
//     //                     fontSize: '16px',
//     //                     color: '#555',
//     //                   },
//     //                 }}
//     //                 error={touched.password && !!errors.password}
//     //                 helperText={touched.password && errors.password}
//     //               />
//     //             </Grid>

//     //             {/* <Grid item xs={12}>
//     //               <Field
//     //                 as={TextField}
//     //                 name='phone'
//     //                 fullWidth
//     //                 placeholder='Phone'
//     //                 variant='outlined'
//     //                 helperText={<ErrorMessage name='phone' />}
//     //                 error={!!(<ErrorMessage name='phone' />)}
//     //               />
//     //             </Grid>
//     //             <Grid item xs={12}>
//     //               <Field
//     //                 as={TextField}
//     //                 name='password'
//     //                 type='password'
//     //                 placeholder='Password'
//     //                 fullWidth
//     //                 variant='outlined'
//     //                 helperText={<ErrorMessage name='password' />}
//     //                 error={!!(<ErrorMessage name='password' />)}
//     //               />
//     //             </Grid> */}
//     //             <Grid item xs={12}>
//     //               <FormControlLabel
//     //                 control={
//     //                   <Field as={Checkbox} name='rememberMe' color='primary' />
//     //                 }
//     //                 label='Keep me signed in'
//     //               />
//     //             </Grid>
//     //             <Grid item xs={12}>
//     //               <Button
//     //                 type='submit'
//     //                 variant='contained'
//     //                 fullWidth
//     //                 disabled={isSubmitting}
//     //                 sx={{
//     //                   backgroundColor: '#001586',
//     //                   color: '#fff',
//     //                   borderRadius: 4,
//     //                   mb: 2,
//     //                   '&:hover': {
//     //                     backgroundColor: '#155a8a',
//     //                   },
//     //                 }}
//     //               >
//     //                 Login
//     //               </Button>
//     //             </Grid>
//     //           </Grid>
//     //         </Form>
//     //       )}
//     //     </Formik>
//     //   </Paper>
//     // </Box>
//   );
// };

const FormInput = ({
  name,
  type = 'text',
  placeholder,
  handleChange,
  touched,
  errors,
  isMobile,
  togglePasswordVisibility,
  showPassword,
}) => (
  <Grid item xs={11} sx={{ pl: '0px !important', mb: isMobile ? 0 : 2 }}>
    <TextField
      fullWidth
      variant='outlined'
      name={name}
      type={name === 'password' ? (showPassword ? 'text' : 'password') : type}
      placeholder={placeholder}
      onChange={handleChange}
      inputProps={{
        maxLength: name === 'phone' ? 10 : name === 'otp' ? 6 : undefined,
        pattern:
          name === 'phone' ? '[0-9]{10}' : name === 'otp' ? '[0-9]{6}' : undefined,
        inputMode: name === 'phone' || name === 'otp' ? 'numeric' : undefined,
      }}
      InputProps={{
        maxLength: name === 'phone' ? 10 : name === 'otp' ? 6 : undefined,
        pattern:
          name === 'phone' ? '[0-9]{10}' : name === 'otp' ? '[0-9]{6}' : undefined,
        startAdornment: (
          <InputAdornment position='start' sx={{ mr: '0 !important' }}>
            <Box
              sx={{
                width: '6.5px',
                height: '37px',
                backgroundColor: '#001586',
              }}
            />
          </InputAdornment>
        ),
        endAdornment:
          name === 'password' ? (
            <InputAdornment position='end' sx={{ ml: '3px' }}>
              <IconButton
                // aria-label='toggle password visibility'
                onClick={togglePasswordVisibility}
                edge='end'
                sx={{ backgroundColor: '#e7f0fe', borderRadius: 'unset' }}
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : (
            false
          ),
      }}
      sx={{
        '& .MuiOutlinedInput-root': {
          paddingLeft: '1px',
          backgroundColor: 'transparent',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',

          '& fieldset': {
            border: '1px solid #DDD',
          },

          '&:hover': {
            backgroundColor: '#f5f9ff',
          },

          '&:hover fieldset': {
            borderColor: '#1876D1',
          },

          '&.Mui-focused fieldset': {
            borderColor: '#1876D1',
          },
        },

        '& input': {
          padding: '12px 20px',
          fontSize: '16px',
          color: '#555',
        },
      }}
      error={touched[name] && !!errors[name]}
      helperText={touched[name] && errors[name]}
    />
  </Grid>
);

const Login = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    if (values?.phone === '9512292402' && values?.password === 'Ver1fy@36o') {
      const response = await eventService.getEvents();
      if (response?.status === 200) {
        localStorage?.setItem('event_id', find(response?.data, 'active')?.id);
        localStorage?.setItem('permissions', JSON.stringify([]));
        localStorage?.setItem('roles', JSON.stringify(['SYS ADMIN']));
        localStorage?.setItem('user_id', null);
        localStorage?.setItem('user_name', 'SYS ADMIN');
        localStorage?.setItem('phone', values.phone);
        localStorage?.setItem('stations', JSON.stringify([]));
        localStorage?.setItem('products', JSON.stringify([]));
        localStorage?.setItem('zones', '');

        navigate('/stationReport');
      }
    } else {
      try {
        if (isMobile) {
          const generated = await createUserOtp(values.phone);
          if (generated.otp !== String(values.otp || '')) {
            toast?.error('OTP is invalid');
            setErrors({ api: 'OTP is invalid. Please check your OTP.' });
            setSubmitting(false);
            return;
          }
        }
        const res = await authService.login(
          values.phone,
          isMobile ? 'Password@321' : values.password
        );
        const loginRole = res?.roles ? JSON.parse(res.roles)[0] : null;

        if (res) {
          const {
            event_id,
            roles = [],
            permissions = [],
            user_id,
            username,
            gps_units_id,
            gps_units_name,
            stations,
            products,
          } = {
            ...res,
            roles: loginRole
              ? loginRole === 'ADMIN'
                ? ['ADMIN', 'SUPER ADMIN']
                : loginRole === 'SUPERVISOR'
                ? ['SUPERVISOR', 'ADMIN', 'SUPER ADMIN']
                : JSON.parse(res.roles)
              : [],
            permissions: res?.permissions ? JSON.parse(res.permissions) : [],
            product_types:
              res?.product_types && !isEmpty(res?.product_types)
                ? JSON.parse(res.product_types)
                : [],
            department_name:
              res?.department_name && !isEmpty(res?.department_name)
                ? JSON.parse(res.department_name)
                : [],
            products:
              res?.products && !isEmpty(res?.products)
                ? JSON.parse(res?.products)
                : [],
            stations:
              res?.station && !isEmpty(res?.station)
                ? JSON.parse(res?.station)
                : [],
          };

          console.log('roles', roles, permissions);

          localStorage?.setItem('event_id', event_id);
          localStorage?.setItem('permissions', JSON.stringify(permissions));
          localStorage?.setItem('roles', JSON.stringify(roles));
          localStorage?.setItem('user_id', user_id);
          localStorage?.setItem('user_name', username);
          localStorage?.setItem('gps_unit_name', res?.gps_unit_name);
          localStorage?.setItem('phone', values.phone);
          localStorage?.setItem('stations', JSON.stringify(stations));
          localStorage?.setItem('products', JSON.stringify(products));
          localStorage?.setItem('zones', res?.zones || '');

          const hasPermission = (permission) =>
            permissions.includes(permission);

          if (localStorage?.getItem('roles')) {
            if (roles?.includes('ZONE HEAD')) {
              navigate('/location-structure');
            } else if (roles?.includes('USER')) {
              if (hasPermission('AMBULANCE GPS')) {
                if (gps_units_id) {
                  navigate(`/ambulance/${gps_units_id}`);
                } else {
                  toast?.error('GPS unit id is not found!!');
                }
              } else if (hasPermission('SUPERVISOR FORM')) {
                navigate(`/stockHistory`);
              } else if (
                ['ALLOTED ITEM', 'DELIVERED ITEM', 'PICKED-UP ITEM'].some(
                  (item) => hasPermission(item)
                )
              ) {
                if (hasPermission('ALLOTED ITEM')) {
                  navigate('/userAccess?tab=inward');
                } else if (hasPermission('DELIVERED ITEM')) {
                  navigate('/userAccess?tab=delivered');
                } else if (hasPermission('PICKED-UP ITEM')) {
                  navigate('/userAccess?tab=pickup');
                }
              }
              // toast?.error('You do not have any permission view the pages!!');
            } else {
              if (roles?.includes('STATION MANAGER')) {
                navigate('/stationUpdate');
              } else if (
                roles?.includes('COMMAND CENTER') ||
                permissions?.includes('COMMAND CENTER')
              ) {
                navigate('/gpsUnits');
              } else {
                navigate('/users');
              }
            }
          }
        }
      } catch (error) {
        console.error(error);
        toast?.error(error?.response?.data?.message);
        setErrors({ api: 'Login failed. Please check your credentials.' });
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: `url(${
          isMobile ? mobileBackground : desktopBackground
        }) no-repeat center center fixed`,
        backgroundSize: 'cover',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: isMobile ? '100%' : 400,
          maxWidth: 400,
          p: 4,
          borderRadius: 3,
          backdropFilter: !isMobile && 'blur(1px)',
          backgroundColor: !isMobile
            ? 'rgba(255, 255, 255, 0.5)'
            : 'rgba(255, 255, 255, 0.1)',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
          position: 'relative',
          marginLeft: isMobile ? 0 : '35rem',
          marginTop: isMobile ? '0rem' : '6rem',
          paddingBottom: isMobile ? '18rem' : 0,
        }}
      >
        <Box textAlign='center' mb={3}>
          <img
            src={logo}
            alt='Pro360 Logo'
            style={{ width: isMobile ? 200 : 250 }}
          />
          <Typography
            variant='h5'
            mt={1}
            sx={{ color: '#001586', fontWeight: 500 }}
          >
            Login Account
          </Typography>
          <Typography variant='body2' color='textSecondary'>
            {isMobile
              ? 'Enter your mobile number and OTP to access your account.'
              : 'Enter your credentials to access your account.'}
          </Typography>
        </Box>

        <Formik
          initialValues={{
            phone: '',
            password: '',
            otp: '',
          }}
          validationSchema={getValidationSchema(isMobile)}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, touched, errors, handleChange }) => (
            <Form>
              <Grid
                container
                spacing={2}
                sx={{ display: 'flex', justifyContent: 'center' }}
              >
                <FormInput
                  name='phone'
                  placeholder='Phone'
                  handleChange={handleChange}
                  touched={touched}
                  errors={errors}
                  isMobile={isMobile}
                />
                {isMobile && (
                  <FormInput
                    name='otp'
                    placeholder='OTP'
                    handleChange={handleChange}
                    touched={touched}
                    errors={errors}
                    isMobile={isMobile}
                  />
                )}
                {!isMobile && (
                  <FormInput
                    name='password'
                    type='password'
                    placeholder='Password'
                    handleChange={handleChange}
                    touched={touched}
                    errors={errors}
                    isMobile={isMobile}
                    togglePasswordVisibility={togglePasswordVisibility}
                    showPassword={showPassword}
                  />
                )}
                {/* {!isMobile && (
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Field
                          as={Checkbox}
                          name='rememberMe'
                          color='primary'
                        />
                      }
                      label='Keep me signed in'
                    />
                  </Grid>
                )} */}
                <Grid
                  item
                  xs={12}
                  sx={{ pl: '0px !important', mb: isMobile ? 0 : '16px' }}
                >
                  <Button
                    type='submit'
                    variant='contained'
                    fullWidth
                    disabled={isSubmitting}
                    sx={{
                      backgroundColor: '#001586',
                      color: '#fff',
                      borderRadius: 4,
                      mb: 2,
                      '&:hover': {
                        backgroundColor: '#155a8a',
                      },
                    }}
                  >
                    Login
                  </Button>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Paper>
    </Box>
  );
};

export default Login;
